// 子画面の要素を取得
var elm = document.getElementById("parentframe");
var elm02 = document.getElementById("parentframe02");

// 子画面のコンテンツサイズに合わせてサイズを変更する関数
function changeParentHeight(){
  elm.style.height = elm.contentWindow.document.body.scrollHeight + "px";
}
function changeParentHeight02(){
  elm02.style.height = elm02.contentWindow.document.body.scrollHeight + "px";
}

// 親画面 iframe の高さを変更するイベント
// 1. 子画面の読み込み完了時点で処理を行う
elm.contentWindow.onload = function() { 
  changeParentHeight(); 
};
elm02.contentWindow.onload = function() { 
  changeParentHeight02(); 
};

// 2. 子画面のウィンドウサイズ変更が完了した時点で処理を行う
var timer = 0;
var timer02 = 0;

elm.contentWindow.onresize = function () {
  if (timer > 0) {
    clearTimeout(timer);
  }
  timer = setTimeout(function () {
    changeParentHeight();
  }, 100);
};

elm02.contentWindow.onresize = function () {
  if (timer02 > 0) {
    clearTimeout(timer02);
  }
  timer02 = setTimeout(function () {
    changeParentHeight02();
  }, 100);
};

$('.company-wrap').on('inview', function(event, isInView) {
  if (isInView) {
      $(".under-wrap__mv").addClass("fade-box");
  }
  if (isInView) {
      $(".mv-message").addClass("fade-txt");
  }
});

$(function() {
let tabs = $(".tab"); // tabのクラスを全て取得し、変数tabsに配列で定義
$(".tab").on("click", function() { // tabをクリックしたらイベント発火
    $(".active").removeClass("active"); // activeクラスを消す
    $(this).addClass("active"); // クリックした箇所にactiveクラスを追加
    const index = tabs.index(this); // クリックした箇所がタブの何番目か判定し、定数indexとして定義
    $(".body-box").removeClass("show").eq(index).addClass("show"); // showクラスを消して、contentクラスのindex番目にshowクラスを追加
})
})

